<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="d-flex justify-center">
      <v-card style="width: 800px" shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-podium</v-icon>
          <span class="title font-weight-light">Отчёт Рейтинг</span>
        </v-card-title>
        <v-form ref="form">
          <v-col class="d-flex">
            <v-text-field
              class="mx-2"
              v-model="dateStart"
              label="Дата от... (включительно)"
              type="date"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              class="mx-2"
              v-model="dateEnd"
              label="Дата до... (включительно)"
              type="date"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              class="mx-2"
              label="Регион"
              item-text="name"
              item-value="id"
              :items="cityItems"
              :loading="loading.options"
              v-model="cityId"
              persistent-hint
              hint="Весь регион — расчёт по всему Казахстану"
            ></v-autocomplete>
            <v-autocomplete
              class="mx-2"
              label="Филиал"
              item-text="name"
              item-value="id"
              :items="filialItems"
              :loading="loading.options"
              v-model="filialId"
              persistent-hint
              hint="Все филиалы — расчёт по дистрибьютору целиком"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-select
              class="mx-2"
              label="Количество SKU"
              :items="options.skuCountOptions"
              :loading="loading.options"
              v-model="skuCount"
              :rules="[rules.required]"
            ></v-select>
            <v-text-field
              class="mx-2"
              label="Количество Дистрибьюторов"
              type="number"
              :min="options.minCompetitorCount"
              :max="options.maxCompetitorCount"
              v-model.number="competitorCount"
              :rules="competitorCountRules"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex">
            <v-btn
              :loading="loading.download"
              @click="DownloadReport()"
              block
              color="primary"
            >
              Сформировать отчёт
              <template v-slot:loader>
                <span>Отчёт формируется...</span>
              </template>
            </v-btn>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const ALL_REGIONS_ID = 0;
const ALL_FILIALS_ID = 0;

export default {
  data: () => ({
    dateStart: null,
    dateEnd: null,
    cityId: ALL_REGIONS_ID,
    filialId: ALL_FILIALS_ID,
    skuCount: null,
    competitorCount: 3,
    options: {
      cities: [],
      filials: [],
      skuCountOptions: [],
      minCompetitorCount: 1,
      maxCompetitorCount: 5,
      defaultCompetitorCount: 3,
    },
    loading: {
      options: true,
      download: false,
    },
    rules: {
      required: (value) => !!value || "Поле обязательно для заполнения.",
    },
  }),
  computed: {
    cityItems() {
      return [{ id: ALL_REGIONS_ID, name: "Весь регион" }, ...this.options.cities];
    },
    filialItems() {
      const filials =
        this.cityId > ALL_REGIONS_ID
          ? this.options.filials.filter((x) => x.cityId === this.cityId)
          : this.options.filials;

      return [{ id: ALL_FILIALS_ID, name: "Все филиалы" }, ...filials];
    },
    competitorCountRules() {
      return [
        (value) =>
          (value >= this.options.minCompetitorCount &&
            value <= this.options.maxCompetitorCount) ||
          `Допустимо от ${this.options.minCompetitorCount} до ${this.options.maxCompetitorCount}`,
      ];
    },
  },
  mounted() {
    this.GetFilterOptions();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        const options = await this.$store.dispatch("RATING_REPORT_FILTER_OPTIONS");
        this.options = options;
        this.skuCount = options.skuCountOptions[0];
        this.competitorCount = options.defaultCompetitorCount;
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    DownloadReport() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const request = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        cityId: this.cityId,
        filialId: this.filialId,
        skuCount: this.skuCount,
        competitorCount: this.competitorCount,
      };

      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_RATING_REPORT", request)
        .then((hasData) => {
          this.loading.download = false;
          if (hasData === false) {
            this.$store.commit("SET_SNACKBAR", {
              text: "За выбранный период нет продаж",
              timeout: 7500,
              color: "warning",
              linkText: "",
              show: true,
            });
          }
        })
        .catch((error) => {
          this.loading.download = false;
          window.console.log(error);
        });
    },
  },
  watch: {
    cityId() {
      this.filialId = ALL_FILIALS_ID;
    },
  },
};
</script>
